import Vue from 'vue'
import Router from 'vue-router'
import Start from '@/components/Start'
import Rosette from '@/components/Rosette'
import Eckgesimse from '@/components/Eckgesimse'
import Einzelstuecke from '@/components/Einzelstuecke'
import Spiegel from '@/components/Spiegel'
import Zierstaebe from '@/components/Zierstaebe'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:section(products|manufacturing|references|contact)?',
      name: 'home',
      component: Start
    },
    {
      path: '/rosetten/',
      name: 'rosette',
      component: Rosette
    },
    {
      path: '/eckgesimse/',
      name: 'eckgesimse',
      component: Eckgesimse
    },
    {
      path: '/deckenstaebe/',
      name: 'deckenstaebe',
      component: Spiegel
    },
    {
      path: '/zierstaebe/',
      name: 'zierstaebe',
      component: Zierstaebe
    },
    {
      path: '/einzelstuecke/',
      name: 'einzelstuecke',
      component: Einzelstuecke
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js